import React, { useEffect, useState } from "react";
import MainLayout from "../../../../assets/Layout/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import API from "../../../../api/axios";
import { APP_URLS } from "../../../../api/url";
import { toast } from "react-toastify";
import { EditVehicleWrapper } from "../../style/EditVehicle";

const EditModals = () => {

  const search = useLocation().search;
  const query = new URLSearchParams(search);

  const [products, _products] = useState(JSON.parse(localStorage.getItem("productType")));
  const [productValue, _productValue] = useState("1");
  const [name, _name] = useState('');

  const [loading,_loading] = useState(false)

  const [showData, _showData] = useState(false)

  const { modalId } = useParams();

  const navigate = useNavigate()

  useEffect(() => {
    getModal()
  }, [])

  const getModal = () => {
    API.get(APP_URLS.SHOW_MODELS + `/${modalId}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          document.getElementById("name").value = resp.data.modelCar.model_name;
          document.getElementById("brandName").value = resp.data.modelCar.brand_car.name;
          _name(resp.data.modelCar.model_name)
          _productValue(resp.data.modelCar.brand_car.product_type_id)
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        const resp = error.response;
        let error_message = "";
        if (resp?.data?.data !== undefined) {
          {
            Object.keys(resp.data.data).map((error, index) => (error_message = resp.data.data[error][0]));
          }
        } else if (resp?.data?.data?.error !== undefined) {
          error_message = resp.data.data.error;
        } else if (resp?.data?.error !== undefined) {
          error_message = resp?.data.error;
        } else {
          error_message = resp?.data.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleSubmit = () => {
    let data = {}
    data["model_name"] = name
    let flag = false
    if ((name === null || name === "")) {
      toast.error("Please provide model name", {
        position: toast.POSITION.TOP_RIGHT
      })
    }
    else {
      flag = true
    }
    if (flag === true) {
      if(!loading){
        _loading(true)
        API.post(APP_URLS.UPDATE_MODELS + `/${modalId}?_method=patch`, data)
        .then(res => {
            _loading(false)
            const resp = res.data;
            if (resp.success === true) {
              toast.success("Model has been updated successfully.", {
                position: toast.POSITION.TOP_RIGHT,
              });
              navigate("/vehicles-management/vehicle-models?"+
              (query.get("product_type") !== null
                ? "product_type=" + query.get("product_type") + "&"
                : "") +                    
              (query.get("model_name") !== null
                ? "model_name=" + query.get("model_name") + "&"
                : "") +
              (query.get("brand_id") !== null
                ? "brand_id=" + query.get("brand_id") + "&"
                : "") +                
              (query.get("model_id") !== null
                ? "model_id=" + query.get("model_id") + "&"
                : "") +
              (query.get("per_page") !== null 
                ? "per_page=" + query.get("per_page") + "&"
                : "") +
              (query.get("page") !== null
                ? "page=" + query.get("page")
                : "")
            )
            }
            else {
              toast.error(resp.message, {
                position: toast.POSITION.TOP_RIGHT
              })
            }
          })
          .catch(function (error) {
            _loading(false)
            const resp = error.response;
            let error_message = '';
            if (resp.data.data !== undefined && resp.data.data !== null) {
              {
                Object.keys(resp.data.data).map(
                  (error, index) => (error_message = resp.data.data[error][0])
                );
              }
            } else if (resp.data.data?.error !== undefined) {
              error_message = resp.data.data.error;
            } else if (resp.data?.error !== undefined) {
              error_message = resp.data.error
            } else {
              error_message = resp.data.message
            }
            toast.error(error_message, {
              position: toast.POSITION.TOP_RIGHT
            })
          });
      }
    }
  }

  return (
    <>
      <EditVehicleWrapper>
        <div className='mt-2' >
          <div className="backContainer ms-4" onClick={() => navigate("/vehicles-management/vehicle-models?"+
              (query.get("product_type") !== null
                ? "product_type=" + query.get("product_type") + "&"
                : "") +                    
              (query.get("model_name") !== null
                ? "model_name=" + query.get("model_name") + "&"
                : "") +
              (query.get("brand_id") !== null
                ? "brand_id=" + query.get("brand_id") + "&"
                : "") +                
              (query.get("model_id") !== null
                ? "model_id=" + query.get("model_id") + "&"
                : "") +
              (query.get("per_page") !== null 
                ? "per_page=" + query.get("per_page") + "&"
                : "") +
              (query.get("page") !== null
                ? "page=" + query.get("page")
                : "")
            )}>
            <span className='backButton'>x</span>
            <span className='px-3 backButton'>|</span>
            <span className='backButton'>Cancel</span>
          </div>
        </div>
        <div className="headerContainer">
          <h1>EDIT MODELS</h1>
        </div>
        <div className="row">
          <div className="d-flex justify-content-end save-btn mt-3">
          <button className={(loading?"disabled":"")+" add-button"} onClick={handleSubmit} disabled={loading}>Save</button>
          </div>
          <div className="row input-fileds">
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12 mt-3">
                  <label htmlFor="name" className="form-label fieldLabel">
                    Product Type
                  </label>
                  <select
                    name="productType"
                    id="productType"
                    value={productValue}
                    className="form-control mt-3"
                    onChange={(e) => {
                      _productValue(e.target.value);
                    }}
                    disabled
                  >
                    {products.map((item, index) => {
                      return (
                        <option value={item.id} key={index}>
                          {item.item_name.en}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12 mt-4">
                  <label htmlFor="productType" className="form-label fieldLabel product-type d-flex justify-content-between">
                    <span>Brand Name</span>
                  </label>
                  <input type="text" className="form-control mt-3 disabled" disabled
                    placeholder="Brand Name"
                    id="brandName" />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12 mt-3">
                  <label htmlFor="name" className="form-label fieldLabel">
                    Name
                  </label>
                  <input type="text" id="name" name="name"
                    className="form-control mt-3"
                    placeholder="Product Name" onChange={(e) => _name(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </EditVehicleWrapper>
    </>
  );
};

export default EditModals;
